import { useMemo, useState } from "react";
import { Card, Heading, Stack, Text } from "@/components/ui";
import { useAreasAdmin } from "@/features/admin-areas/hooks/use-areas-admin";
import { useNivelesAutorizacion } from "../hooks/use-niveles-autorizacion";
import { agruparPorTipoSubtipo } from "../utils/agrupar-niveles";
import { NivelesHeader } from "./NivelesHeader";
import { NivelCrearForm } from "./NivelCrearForm";
import { NivelesMatriz } from "./NivelesMatriz";

/**
 * Página de administración de niveles · consume dos suspense queries
 * (niveles + áreas) que el loader del route precarga en paralelo.
 *
 * Los niveles se renderizan como MATRIZ agrupada por (tipo, subtipo): cada
 * grupo es una sección colapsable con una tabla área × nivel (mucho más
 * compacta que un card por combinación · ver NivelesMatriz).
 */
export function AdminNivelesAutorizacionPage() {
  const { data: niveles } = useNivelesAutorizacion();
  const { data: areas } = useAreasAdmin();
  const [modoCrear, setModoCrear] = useState(false);

  const grupos = useMemo(() => agruparPorTipoSubtipo(niveles, areas), [niveles, areas]);

  // "Flujos" = combinaciones únicas (tipo, subtipo, área) · se mantiene el
  // conteo aunque la vista agrupe por (tipo, subtipo).
  const totalFlujos = useMemo(
    () => new Set(niveles.map((n) => `${n.tipo}__${n.subtipo}__${n.areaId}`)).size,
    [niveles]
  );

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <NivelesHeader
        totalGrupos={totalFlujos}
        totalNiveles={niveles.length}
        modoCrear={modoCrear}
        onIniciarCrear={() => setModoCrear(true)}
      />
      <Stack gap="md">
        {modoCrear ? <NivelCrearForm areas={areas} onSalir={() => setModoCrear(false)} /> : null}
        {grupos.length === 0 ? (
          <Card padding="lg">
            <Stack gap="xs">
              <Heading order={5}>Sin niveles configurados</Heading>
              <Text size="sm" c="dimmed">
                Agrega al menos un nivel para que las solicitudes puedan enviarse a autorización.
              </Text>
            </Stack>
          </Card>
        ) : (
          <NivelesMatriz grupos={grupos} />
        )}
      </Stack>
    </div>
  );
}
